import { LinkButton } from '@components/button/link'
import * as ICONS from '@components/icons/social'
import type { IconProps } from '@components/icons/types'
import { LINK } from '@shared/util/link'
import type { FunctionComponent } from 'react'

/** Social network page button */
export const SocialButton: FunctionComponent<
    React.PropsWithChildren<Props>
> = ({ type, height, width, color, ...restOfProps }) => {
    const href = LINK.social[type]
    const Icon = ICONS[type]

    if (!href) return null

    return (
        <LinkButton
            size='medium'
            preset='anchor'
            key={type}
            href={href}
            target='_blank'
            rel='noopener noreferrer'
            title={type}
            {...restOfProps}
        >
            <Icon height={height} width={width} color={color} />
        </LinkButton>
    )
}

interface Props extends IconProps {
    type: keyof typeof ICONS
}
